/** biome-ignore-all lint/a11y/noSvgWithoutTitle: its ok */
"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import ExtendedImage from "@/components/ui/extended-image";

const REDIRECT_DELAY_MS = 3000;
const PROGRESS_INTERVAL_MS = 16;
const PROGRESS_FULL = 100;
const PROGRESS_EMPTY = 0;

interface RedirectPageProps {
  redirectUrl: string;
}

export default function RedirectPage({ redirectUrl }: RedirectPageProps) {
  const [progress, setProgress] = useState(PROGRESS_FULL);

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      window.location.href = redirectUrl;
    }, REDIRECT_DELAY_MS);

    const startTime = Date.now();
    const progressInterval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(
        PROGRESS_EMPTY,
        PROGRESS_FULL - (elapsed / REDIRECT_DELAY_MS) * PROGRESS_FULL,
      );
      setProgress(remaining);
    }, PROGRESS_INTERVAL_MS);

    return () => {
      clearTimeout(redirectTimer);
      clearInterval(progressInterval);
    };
  }, [redirectUrl]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-8 px-6 text-center">
        <div className="flex items-center gap-6">
          <ExtendedImage
            alt="bebek.com"
            height={54}
            loading="lazy"
            src="/assets/bebek-com-logo.svg"
            width={140}
          />

          <div className="flex items-center gap-1 text-gray-300">
            <svg fill="none" height="20" viewBox="0 0 28 20" width="28">
              <path
                d="M1 10h18M13 3l7 7-7 7"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
            <svg fill="none" height="20" viewBox="0 0 16 20" width="16">
              <path
                d="M1 10h10M5 3l7 7-7 7"
                stroke="#F7901E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
          </div>

          <Image
            alt="ebebek"
            height={54}
            src="/assets/ebebek.svg"
            width={140}
          />
        </div>

        <div className="flex flex-col gap-3">
          <h1 className="text-xl font-semibold text-[#0091D5]">
            ebebek.com&apos;a yönlendiriliyorsunuz
          </h1>
          <p className="max-w-sm text-sm text-gray-500">
            ebebek hesabınızla giriş yaparak bebek.com&apos;daki
            kişiselleştirilmiş içeriklere ve kayıtlı bilgilerinize kolayca
            erişebilirsiniz.
          </p>
        </div>

        <div className="w-64 overflow-hidden rounded-full bg-gray-100">
          <div
            className="h-1 rounded-full bg-[#0091D5] transition-none"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className="text-sm text-gray-500">
          Otomatik yönlendirilemezseniz{" "}
          <a className="text-[#0091D5] underline" href={redirectUrl}>
            tıklayın.
          </a>
        </p>
      </div>
    </div>
  );
}
